import { B2BCartsApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const cartCurrentClient = new B2BCartsApi(ecomConfiguration)
